// extracted by mini-css-extract-plugin
export default {"answerCardsGroup":"HandwritingGameAnswerCardsGroup_answerCardsGroup__8sY6H","answerCardWrapper":"HandwritingGameAnswerCardsGroup_answerCardWrapper__cQ-PL"};